import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, input, output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { Router } from '@angular/router';
import { ToggleButtonModule } from 'primeng/togglebutton';

@Component({
  selector: 'app-table-read-only',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ToolbarComponent,
    FormsModule,
    ToastModule,
    TagModule,
    DropdownModule,
    ButtonModule,
    InputTextModule,
    RippleModule,
    CheckboxModule,
    RadioButtonModule,
    InputGroupModule,
    InputGroupAddonModule,
    CalendarModule,
    ReactiveFormsModule,
    MultiSelectModule,
    ToggleButtonModule,
  ],
  templateUrl: './table-read-only.component.html',
  styleUrl: './table-read-only.component.css',
})
export class TableReadOnlyComponent implements OnInit {
  @Input() tableHeader: any = [];
  @Input() tableBody: any = [];
  @Input() newRow: any;
  tblHeader = input<any[]>([]);
  fieldInputType = input<any[]>([]);
  editedLine = output<any[]>();
  newElement: any[] = [];
  // isDisabled = input<boolean>();
  loading = input<boolean>();

  showAddNewButton: boolean = false;
  showAddingForm: boolean = false;
  showToolbar: boolean = false;
  selectedData: String = '';

  isEditable = input<boolean>();

  radioValue1: boolean = false;

  checked: boolean = false;

  category: string | undefined;

  date: Date | undefined;

  cols!: any[];

  selectedProducts!: any[];

  metaKey: boolean = true;
  clonedProducts: { [s: string]: any } = [];
  newLineButton: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  selectColumn(column: any) {
    console.log(column);
  }

  showFormToAddNewValue() {
    this.showAddingForm = true;
  }

  // addNewElement($event: any) {
  // console.log($event);
  // this.tableBody.push($event);
  // }

  addNewLine() {
    this.newLineButton = true;
    this.tableBody.unshift(this.tableHeader);
    // this.tableBody.push(this.newRow);
    console.log('this.tableBody[0]');
    console.log(this.tableBody[0]);
    console.log('this.tableBody[1]');
    console.log(this.tableBody[1]);

    // this.onRowEditInit(this.tableBody[0]);
    // this.onRowEditInit(this.tableBody[0]);
  }

  onRowEditInit(product: any) {
    this.clonedProducts[product.id as string] = { ...product };
    console.log(product);
  }

  onRowEditSave(product: any) {
    this.editedLine.emit(product);
    delete this.clonedProducts[product.id as string];
  }

  onRowEditCancel(product: any, index: number) {
    this.tableBody[index] = this.clonedProducts[product.id as string];
    delete this.clonedProducts[product.id as string];
  }

  deleteRow(row: any) {
    this.tableBody = this.tableBody.filter((ele: { id: any }) => ele.id !== row.id);
  }

  selectData(data: any) {
    this.selectedData = data;
    console.log(this.selectedData);
  }
}
